

import {
    translateAboutBtn, hideGallery, hideDetails, unPutMainImageFullScreen, collapseBackBtnAnimation, showTBQT, executeCentralTextFunction, collapseTBQT,
    showBackBtnAnimation,
    allColEmpty,
    showGallery,
    putMainImageFullScreen, showDetails,
    moveOutScreendown, showAboutTextAnimation, moveUpCentralElements, showAboutSection, hideAboutSection, replaceCentralElements,
    removeTransitionFor,
    
    showRetronewsTextAnimation,
    endCursorHoverLineAnimation,
    enableAboutBtnHover,
    disableAboutBtnHover,
    showDetailsMobile,
    hideHomeMobile,
    hideDetailMobile,
    detailToHomeFirstPart,
    detailToHomeSecondPart,
} from "./util";
import { revealInstantCaroussel, revealInstantCarousselAtProject, revealCaroussel, getIndexInFront } from "./threeScript"

function getTransitionStep(from, to, router) {
    const aboutToHome = [
        {
            timing: 0,
            action: () => {
                replaceCentralElements();
                executeCentralTextFunction(getIndexInFront());
                translateAboutBtn(0);
                hideAboutSection();

            }

        },
        {
            timing: 0.2,
            action: () => {
                const canvas = document.querySelector(".webgl");

                canvas.style.transform = "translate(0px, 0px)"
            },
        }
    ]

    const homeToAbout = [
        {
            timing: 0,
            action: () => {
                const canvas = document.querySelector(".webgl");
                moveOutScreendown(canvas);
                showAboutTextAnimation();
                translateAboutBtn(-1);
                moveUpCentralElements();

            }

        },
        {
            timing: 0.4,
            action: () => {
                showAboutSection();
            },
        }
    ]
    const detailToHome = [
        {
            timing: 0,
            action: () => {
                translateAboutBtn(0);
                hideDetails();
                hideGallery(router.lastRoute.props.imgSelected);
                collapseBackBtnAnimation();
                endCursorHoverLineAnimation();
                enableAboutBtnHover();

            }
        },
        {
            timing: 0.25,
            action: () => {
                unPutMainImageFullScreen();
                showTBQT();
                executeCentralTextFunction(getIndexInFront());


            }
        },
    ]

    const homeToDetail = [
        {
            timing: 0,
            action: () => {
                disableAboutBtnHover();
                endCursorHoverLineAnimation();
                allColEmpty();
                putMainImageFullScreen();
                translateAboutBtn(1);
                showBackBtnAnimation();
                collapseTBQT();

                router.actualRoute.props.imgSelected = 1;
                // initGalleryPosition();

            }
        },
        {
            timing: 0.5,
            action: () => {
                showGallery();

            }
        },
        {
            timing: 0.9,
            action: () => {
                showDetails();
            }
        }


    ]

    const loadToAbout = [
        {
            timing: 0,
            action: () => {
                const canvas = document.querySelector(".webgl");
                removeTransitionFor(canvas, 150);
                moveOutScreendown(canvas);
                showAboutTextAnimation();
                translateAboutBtn(-1);
                moveUpCentralElements();
                revealInstantCaroussel();

            }

        },
        {
            timing: 0.4,
            action: () => {
                showAboutSection();
                enableAboutBtnHover();

            },
        }
    ]
    const loadToDetail = [
        {
            timing: 0,
            action: () => {
                allColEmpty();
                const canvas = document.querySelector(".webgl");

                removeTransitionFor(canvas, 150);
                canvas.style.opacity = "0";
                putMainImageFullScreen();

                revealInstantCarousselAtProject(router.actualRoute.props.projectIndex);
                setTimeout(() => { canvas.style.opacity = 1 }, 150);
                translateAboutBtn(1);
                showBackBtnAnimation();
                collapseTBQT();
                disableAboutBtnHover();

            }
        },
        {
            timing: 0.5,
            action: () => {
                showGallery();

            }
        },
        {
            timing: 0.9,
            action: () => {
                showDetails();
            }
        }


    ]
    const loadToHome = [
        {

            timing: 0,
            action: () => {
                setTimeout(revealCaroussel, 1000);
                setTimeout(showRetronewsTextAnimation, 3000);
                setTimeout(enableAboutBtnHover, 3500);
                setTimeout(translateAboutBtn, 3500, 0);

            }
        },



    ]

    const loadToAboutMobile=[
        {
            timing: 0,
            action: () => {
                document.getElementById('about-section').scrollIntoView();

            }

        },
    ]
    const loadToDetailMobile=[
        {
            timing: 0,
            action: () => {
                showDetailsMobile();
                executeCentralTextFunction(router.actualRoute.props.projectIndex);
                
            }

        },
    ]
    const homeToDetailMobile=[
        {
            timing:0,
            action:()=>{
                hideHomeMobile()
            }
        },
        {
            timing: 0.9,
            action: () => {
                showDetailsMobile();
                executeCentralTextFunction(router.actualRoute.props.projectIndex);

            }

        },
    ]
    const detailToHomeMobile=[
        {
            timing: 0,
            action: () => {
                hideDetailMobile();
                

            }

        },
        {
            timing:0.8,
            action:()=>{
                detailToHomeFirstPart();
                document.body.scrollTo(0, router.lastScrollTop) ;
               
            }
        },
        {
            timing:0.9,
            action:()=>{
                detailToHomeSecondPart();
                
            }
        }
    ]



    var transitions = {};
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    if (vw > 950) {
        transitions = {
            "/": {
                "/mobile-food": homeToDetail,
                "/anazir": homeToDetail,
                "/repreneur": homeToDetail,
                "/retronews": homeToDetail,
                "/about": homeToAbout

            },
            "/mobile-food": {
                "/": detailToHome
            },
            "/anazir": {
                "/": detailToHome
            },
            "/repreneur": {
                "/": detailToHome
            },
            "/retronews": {
                "/": detailToHome
            },
            "/about": {
                "/": aboutToHome
            },
          
            "load": {
                "/about": loadToAbout,
                "/mobile-food": loadToDetail,
                "/anazir": loadToDetail,
                "/repreneur": loadToDetail,
                "/retronews": loadToDetail,
                "/": loadToHome,
            }

        }
    }
    else {
        transitions = {
            "/": {
                "/mobile-food": homeToDetailMobile,
                "/anazir": homeToDetailMobile,
                "/repreneur": homeToDetailMobile,
                "/retronews": homeToDetailMobile,

            },
            "/mobile-food": {
                "/": detailToHomeMobile
            },
            "/anazir": {
                "/": detailToHomeMobile
            },
            "/repreneur": {
                "/": detailToHomeMobile
            },
            "/about": {
                "/": []
            },
            "/retronews": {
                "/": detailToHomeMobile
            },
            "load": {
                "/about": loadToAboutMobile,
                "/mobile-food": loadToDetailMobile,
                "/anazir": loadToDetailMobile,
                "/repreneur": loadToDetailMobile,
                "/retronews": loadToDetailMobile,
                "/":[]
                
            }

        }
    }
    return transitions[from][to];




}

export { getTransitionStep };